// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1V7xI","img":"styles_img__3tK4K","rotate":"styles_rotate__2PFVK"};